import { Injectable } from '@angular/core';
import { Converter, Occ, Product } from '@spartacus/core';

export interface CustomProduct extends Product {
  productUrl?: string;
}

@Injectable()
export class CustomProductNormalizer implements Converter<Occ.Product, CustomProduct> {
  convert(source: Occ.Product, target: CustomProduct): CustomProduct {
    if (source.url) {
      const pCode = source.url.slice(1);
      const decodedUrl = decodeURIComponent(pCode);
      target['productUrl'] = decodedUrl;
      target['url'] = decodedUrl;
    }
    return target;
  }
}
